import { createAsyncThunk } from '@reduxjs/toolkit';

import { districteService } from 'src/services/districte';

import { setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const loadDistrictes = createAsyncThunk<string[], void, { state: ICoreState }>('districte/loadDistrictes', async (_data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const { isLoggedIn } = getState().user;
        if (!isLoggedIn) {
            return null;
        }
        dispatch(setLoadingStatus(true));
        const { data } = await districteService.getDistrictesByFilter({}, 1, 100);
        const districtes = data.map(d => d.nom);
        dispatch(setLoadingStatus(false));
        return districtes;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});
